<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="./../../assets/loader.svg" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
      <b-card no-header>
        <template slot="header">User Details</template>
        <b-row v-if="user">
          <b-col cols="12" md="6">
            <b-row>
              <b-col cols="5" xl="3">
                <span class="item_title"> Name</span>
              </b-col>
              <b-col cols="7" xl="9">
                <span class="item_value">{{ user.name }}</span>
              </b-col>
            </b-row>
            <hr />
          </b-col>
          <b-col cols="12" md="6">
            <b-row>
              <b-col cols="5" xl="3">
                <span class="item_title">Mobile No</span>
              </b-col>
              <b-col cols="7" xl="9">
                <span class="item_value">{{ user.mobileno }}</span>
              </b-col>
            </b-row>
            <hr />
          </b-col>
          <!-- <b-col cols="12" md="6">
            <b-row>
              <b-col cols="2">
                <span class="item_title">Email ID</span>
              </b-col>
              <b-col cols="10">
                <span class="item_value">{{ user.email }}</span>
              </b-col>
            </b-row>
            <hr />
          </b-col> -->
          <b-col cols="12" md="6">
            <b-row>
              <b-col cols="5" xl="3">
                <span class="item_title">Username</span>
              </b-col>
              <b-col cols="7" xl="9">
                <span class="item_value">{{ user.username }}</span>
              </b-col>
            </b-row>
            <hr />
          </b-col>
          <b-col cols="12" md="6">
            <b-row>
              <b-col cols="5" xl="3">
                <span class="item_title">Address</span>
              </b-col>
              <b-col cols="7" xl="9">
                <span class="item_value">
                  {{ user.address.addr1 }}, &nbsp;
                  {{ user.address.addr2 }},&nbsp;
                  {{ user.address.pincode }}
                </span>
              </b-col>
            </b-row>
            <hr />
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card no-header>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="3" class="py-2">
                <span>Orders</span>
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="orders"
            :fields="fields"
            @row-clicked="rowClicked"
          >
            <template v-slot:cell(name)="data">
              <span v-if="data.item.name.length > 50">{{
                data.item.name.slice(0, 50) + "..."
              }}</span>
              <span v-else>{{ data.item.name }}</span>
            </template>
            <template v-slot:cell(order_items)="data">
              <span>{{ data.item.order_items.length }}</span>
            </template>
            <!-- <template v-slot:cell(status)="data">
              <span>{{ data.item.status }}</span>
            </template> -->
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalData"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
              @change="nextPage"
            />
          </nav>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
import store from "../../store";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      user: {
        address: {},
      },
      orderStatuses: [
        { name: "Payment Not Confirmed", value: 1 },
        { name: "Placed", value: 2 },
        { name: "Cancelled", value: 3 },
        { name: "Rejected", value: 4 },
        { name: "Confirmed", value: 5 },
        { name: "Delivery En Route", value: 6 },
        { name: "Deliver Complete", value: 7 },
      ],
      msg: null,
      orders: [],
      fields: [
        { key: "customer.name", label: "Name", sortable: false },
        { key: "order_items", label: "Ordered Items", sortable: false },
        { key: "price", label: "Price", sortable: false },
        { key: "status", label: "Status", sortable: false },
      ],
      totalData: 0,
      currentPage: 1,
      perPage: 200,
      totalRows: 0,
    };
  },
  beforeMount() {
    this.getData();
    this.getOrders();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/user/" + this.$route.params.id,
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: {
          shop: localStorage.getItem("shopid"),
          item: this.$route.params.productId,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
          this.appLoading = false;
        });
    },
    nextPage(ev) {
      this.currentPage = ev;
      this.getCategory();
    },

    getOrders() {
      this.appLoading = true;
      axios({
        url: "/order/my/all/",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        params: {
          id: this.$route.params.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.data) {
            this.orders = response.data.data;
            for (var i = 0; i < this.orders.length; i++) {
              for (var j = 0; j < this.orderStatuses.length; j++) {
                if (this.orders[i].status == this.orderStatuses[j].value) {
                  this.orders[i].status = this.orderStatuses[j].name;
                }
              }
            }
          }
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    rowClicked(item) {
      this.$router.push("/Orders/" + item._id);
    },
  },
};
</script>